import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../../common/cookie-helper';
import { DeviceTypeHelper } from '../../../common/device-type-helper';
import { ErrorHandlerHelperDirective } from '../../../common/error-handler/error-handler-helper.directive.';
import { ErrorHandlerDirective } from '../../../common/error-handler/error-handler.directive';
import { ApplicationConfig } from '../../../config/config';
import { ContentBook } from '../../../model/content/contentbook.model';
import { RecentSearch } from '../../../model/recent-search.model';
import { TrackerDataService } from '../../../services/acctactvty/trackerData.service';
import { CommonService } from '../../../services/common.service';
import { ContentHeaderFooterService } from '../../../services/content/contentheaderfooter.service';
import { BookParameters } from './../../../model/bookparameter.model';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'ngc-childPassenger',
  templateUrl: 'childPassenger.component.html'
})
export class ChildPassengerComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @ViewChild('fromAirportElement') fromAirportElementRef: ElementRef;
  @Input() index: number;
  @Input() flightFormGroup: UntypedFormGroup;
  @Input() bookContent: ContentBook;
  @Input() errorHandler: ErrorHandlerDirective;
  @ViewChild(ErrorHandlerHelperDirective)
  errorHandlerHelper: ErrorHandlerHelperDirective;

  @Input() flightData;
  @Input() deviceTypes: any;
  @Output() setPassenger = new EventEmitter();
  @Input() queryParam: BookParameters;
  @Input() custId;
  trackerServiceRecentSearchesSubscribe: Subscription;
  indexOfItemInErrorDirective;
  passengerLabel = '';
  content: any;
  vaPassenger: any;
  numOfPax = 0;
  listVisible = true;
  enterEvent = true;
  adultCount: number;
  yngAdultCount: number;
  childCount: number;
  infantCount: number;
  totalCount = 1;
  adultFlag = false;
  queryParamFlag = false;
  recentSearches: RecentSearch[] = [];
  recentSearchSelected: RecentSearch;
  recentSearchsAvailable = false;
  contentServiceHeaderFooterSubscribe: Subscription;
  deviceTypeSubscribe: Subscription;
  totalPassengerDescription: any;
  paxAdults: any = 'ADT';
  paxYoungAdult: any = 'GBE';
  paxChild: any = 'CNN';
  paxLapInfants: any = 'INF';
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private cdf: ChangeDetectorRef,
    private contentService: ContentHeaderFooterService,
    private el: ElementRef,
    private ren: Renderer2,
    private srv: CommonService,
    private _deviceTypeHelper: DeviceTypeHelper,
    private config: ApplicationConfig,
    private trackerDataService: TrackerDataService,
    public cookieHelper: CookieHelper,
    private loggingService: LoggingService
  ) {}

  ngOnInit() {
    if (this.config.onBrowser) {
      this.setRecentSearchesAirport();
      this.deviceTypeSubscribe = this._deviceTypeHelper
        .deviceDetection()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resp) => {
          this.deviceTypes = resp;
        });
    }
    if (this.contentService.contentHeaderFooter) {
      this.contentServiceHeaderFooterSubscribe =
        this.contentService.contentHeaderFooter
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(
            (data) => {
              if (data) {
                this.content =
                  data.header.primaryNavigations.get('book').details;
                this.vaPassenger = this.content.passengertype;
                const urlParam = window.location.search;
                this.queryParamFlag =
                  this.queryParam !== undefined && this.queryParam.isQueryParam
                    ? true
                    : false;
                if (this.vaPassenger.length !== 0) {
                  this.setPassengers();
                }
              }
            },
            (err) => {
              this.loggingService.log('Caught Error: ' + err);
            }
          );
    }

    this.ren.listen(document, 'click', (event) => {
      const modal = document.querySelector('.modal-content'),
        modalBody = document.querySelector('.modal-body'),
        paxList = this.el.nativeElement.querySelector('.paxList'),
        paxoptionUL = this.el.nativeElement.querySelector('.pax-optionUL'),
        paxDropdown = this.el.nativeElement.querySelector('.pax-wrapper');
      if (
        !this.listVisible &&
        !this.enterEvent &&
        event.target.offsetParent !== null &&
        event.target.offsetParent.parentElement !== paxoptionUL &&
        event.target.parentElement !== paxDropdown &&
        event.target.offsetParent !== modal &&
        event.target.offsetParent !== modalBody
      ) {
        this.ren.addClass(paxList, 'hideOption');
        this.ren.addClass(paxDropdown, 'downArrow-icon');
        this.ren.removeClass(paxDropdown, 'upArrow-icon');
        this.listVisible = true;
        this.enterEvent = true;
      } else {
        this.enterEvent = false;
      }
    });
  }

  async setRecentSearchesAirport() {
    const recentSearchCallParams = this.getRecentSearchCallParams();

    this.trackerServiceRecentSearchesSubscribe =
      recentSearchCallParams.serviceCall
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (res) => {
            if (res !== null && res !== undefined && res !== '') {
              if (recentSearchCallParams.multicity && res.value) {
                console.log(
                  '%c a multicity value was successfully retrieved as below',
                  'color: black'
                );
                console.log(res.value);
                res = [res.value];
              }
              if (res.length > 0) {
                res.forEach((resp, index) => {
                  this.recentSearches.push(new RecentSearch(resp));
                });
                if (this.recentSearches.length > 0) {
                  this.recentSearchSelected = this.recentSearches[0];
                  this.recentSearchsAvailable = true;
                  this.setPassengers();
                }
              }
            }
          },
          (err) => {
            this.loggingService.log('Caught Error: ' + err);
          }
        );
  }

  ngAfterViewInit() {
    if (
      this.errorHandler &&
      this.errorHandler instanceof ErrorHandlerDirective
    ) {
      this.indexOfItemInErrorDirective =
        this.errorHandler.addErrorHandlerHelper(this.errorHandlerHelper);
    }
    for (let i = 0; i < this.vaPassenger.length; i++) {
      const paxAdultIcon = document.querySelector(
        '.pax-optionUL li.pax-' +
          this.vaPassenger[i].passengertypeId +
          ' .remove-pax a'
      );
      if (
        paxAdultIcon && this.vaPassenger[i].passengertypeId === this.paxAdults &&
        this.vaPassenger[i].passengerCount ===
          this.vaPassenger[i].passengerMinCount
      ) {
        this.ren.addClass(paxAdultIcon, 'remove-img');
        this.ren.removeClass(paxAdultIcon, 'active-remove-img');
      }
    }
  }

  ngOnChanges(chnages: SimpleChanges) {}

  getPaxCunt(paxCount, index) {
    let count = paxCount === undefined || paxCount === null ? 0 : paxCount;
    if (count === 0) {
      count = this.vaPassenger[index].passengerMinCount;
    } else {
      count = count;
    }
    return count;
  }

  setPassengers() {
    if (this.vaPassenger !== undefined) {
      for (let i = 0; i < this.vaPassenger.length; i++) {
        if (this.vaPassenger[i].passengertypeId === 'ADT') {
          this.vaPassenger[i].passengerCount = this.recentSearchsAvailable
            ? this.getPaxCunt(this.recentSearchSelected.adtCount, i)
            : this.queryParamFlag
            ? this.getCount(
                this.queryParam.adtCount || this.queryParam.paxCount,
                i
              )
            : this.vaPassenger[i].passengerCount;
          this.adultCount = this.vaPassenger[i].passengerCount;
          this.totalCount = parseInt(this.vaPassenger[i].passengerCount);
        } else if (this.vaPassenger[i].passengertypeId === 'GBE') {
          this.vaPassenger[i].passengerCount = this.recentSearchsAvailable
            ? this.getPaxCunt(this.recentSearchSelected.gbeCount, i)
            : this.queryParamFlag
            ? this.getCount(this.queryParam.gbeCount, i)
            : this.vaPassenger[i].passengerCount;
          this.yngAdultCount = this.vaPassenger[i].passengerCount;
          this.totalCount =
            this.totalCount + parseInt(this.vaPassenger[i].passengerCount);
        } else if (this.vaPassenger[i].passengertypeId === 'CNN') {
          this.vaPassenger[i].passengerCount = this.recentSearchsAvailable
            ? this.getPaxCunt(this.recentSearchSelected.cnnCount, i)
            : this.queryParamFlag
            ? this.getCount(this.queryParam.childCount, i)
            : this.vaPassenger[i].passengerCount;
          this.childCount = this.vaPassenger[i].passengerCount;
          this.totalCount =
            this.totalCount + parseInt(this.vaPassenger[i].passengerCount);
        } else if (this.vaPassenger[i].passengertypeId === 'INF') {
          this.vaPassenger[i].passengerCount = this.recentSearchsAvailable
            ? this.getPaxCunt(this.recentSearchSelected.infantCount, i)
            : this.queryParamFlag
            ? this.getCount(this.queryParam.infantCount, i)
            : this.vaPassenger[i].passengerCount;
          this.infantCount = this.vaPassenger[i].passengerCount;
          this.totalCount =
            this.totalCount + parseInt(this.vaPassenger[i].passengerCount);
        }
      }
      this.setPassengerValues();
    }
  }

  getCount(value, index) {
    let count = value !== undefined && value !== '' ? parseInt(value) : 0;
    if (count === 0) {
      count = this.vaPassenger[index].passengerCount;
    } else {
      count = count;
    }
    return count;
  }

  inputFocus(event) {}

  inputBlur(event) {}

  markAsTouchedFrom() {}

  ngOnDestroy() {
    if (this.errorHandler) {
      this.errorHandler.removeErrorHanlderHelper(
        this.indexOfItemInErrorDirective
      );
    }
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    if (this.trackerServiceRecentSearchesSubscribe) {
      // Load  ObsUnsub
      this.trackerServiceRecentSearchesSubscribe.unsubscribe();
    }
    if (this.deviceTypeSubscribe) {
      // Load  ObsUnsub
      this.deviceTypeSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.cdf.detach();
  }

  showPax(event) {
    if (event.which !== 13 || event.keyCode !== 13) {
      const paxList = this.el.nativeElement.querySelector('.paxList'),
        paxDropdown = this.el.nativeElement.querySelector('.pax-wrapper');
      if (this.listVisible) {
        this.ren.removeClass(paxList, 'hideOption');
        this.ren.removeClass(paxDropdown, 'downArrow-icon');
        this.ren.addClass(paxDropdown, 'upArrow-icon');
        this.listVisible = false;
      }
    }
    this.el.nativeElement.querySelector('.pax-optionUL').focus();
    this.el.nativeElement
      .querySelector('.pax-optionUL')
      .setAttribute('aria-expanded', 'true');
    this.cdf.detectChanges();
  }

  onPaxTabKey(event: any, index) {
    if (
      event.keyCode === 9 &&
      this.vaPassenger[index].passengertypeId === 'INF'
    ) {
      this.closePax(event);
    }
  }

  closePax(event) {
    if (event.which !== 13 || event.keyCode !== 13) {
      const paxList = this.el.nativeElement.querySelector('.paxList'),
        paxDropdown = this.el.nativeElement.querySelector('.pax-wrapper');
      this.ren.addClass(paxList, 'hideOption');
      this.ren.addClass(paxDropdown, 'downArrow-icon');
      this.ren.removeClass(paxDropdown, 'upArrow-icon');
      paxDropdown.focus();
      this.listVisible = true;
    }
    this.el.nativeElement
      .querySelector('.pax-optionUL')
      .setAttribute('aria-expanded', 'false');
    this.cdf.detectChanges();
  }

  openPassenger(event) {
    if (event.which === 13 || event.keyCode === 13) {
      this.enterEvent = true;
      const paxList = this.el.nativeElement.querySelector('.paxList'),
        paxDropdown = this.el.nativeElement.querySelector('.pax-wrapper');
      this.ren.removeClass(paxList, 'hideOption');
      this.ren.removeClass(paxDropdown, 'downArrow-icon');
      this.ren.addClass(paxDropdown, 'upArrow-icon');
      this.listVisible = false;
    }
    this.el.nativeElement.querySelector('.pax-optionUL').focus();
    this.el.nativeElement
      .querySelector('.pax-optionUL')
      .setAttribute('aria-expanded', 'true');
    this.cdf.detectChanges();
  }

  closePassenger(event) {
    if (event.which === 13 || event.keyCode === 13) {
      const paxList = this.el.nativeElement.querySelector('.paxList'),
        paxDropdown = this.el.nativeElement.querySelector('.pax-wrapper');
      this.ren.addClass(paxList, 'hideOption');
      this.ren.addClass(paxDropdown, 'downArrow-icon');
      this.ren.removeClass(paxDropdown, 'upArrow-icon');
      paxDropdown.focus();
      this.listVisible = false;
      this.enterEvent = true;
    }
    this.el.nativeElement
      .querySelector('.pax-optionUL')
      .setAttribute('aria-expanded', 'false');
  }

  addPax(adultCount, index, maxCount) {
    adultCount = parseInt(adultCount);
    maxCount = parseInt(maxCount);
    const paxAdultIcon = document.querySelector(
      '.pax-optionUL li.pax-' +
        this.vaPassenger[index].passengertypeId +
        ' .remove-pax a'
    );
    if (adultCount < maxCount) {
      this.vaPassenger[index].passengerCount =
        parseInt(this.vaPassenger[index].passengerCount) + 1;
      this.totalCount = this.totalCount + 1;
      this.setPassengerValues();
    }
    if (
      this.vaPassenger[index].passengertypeId === this.paxLapInfants &&
      this.vaPassenger[index].passengerCount === 1
    ) {
      this.el.nativeElement
        .querySelector(
          'li.pax-' +
            this.vaPassenger[index].passengertypeId +
            ' .va-child-tooltip-icon'
        )
        .click();
    }
    if (
      this.vaPassenger[index].passengertypeId === this.paxAdults &&
      this.vaPassenger[index].passengerCount >
        this.vaPassenger[index].passengerMinCount
    ) {
      this.addTabFocus(index);
    } else if (
      this.vaPassenger[index].passengertypeId === this.paxYoungAdult &&
      this.vaPassenger[index].passengerCount === 1
    ) {
      this.addTabFocus(index);
    } else if (
      this.vaPassenger[index].passengertypeId === this.paxChild &&
      this.vaPassenger[index].passengerCount === 1
    ) {
      this.addTabFocus(index);
    }
  }

  addTabFocus(index) {
    const paxAdultIcon = document.querySelector(
      '.pax-optionUL li.pax-' +
        this.vaPassenger[index].passengertypeId +
        ' .remove-pax a'
    );
    if (paxAdultIcon !== undefined || paxAdultIcon !== null) {
      this.ren.removeClass(paxAdultIcon, 'remove-img');
      this.ren.removeAttribute(paxAdultIcon, 'tabindex');
    }
  }

  removePax(adultCount, index, minCount) {
    minCount = parseInt(minCount);
    const paxAdultIcon = document.querySelector(
      '.pax-optionUL li.pax-' +
        this.vaPassenger[index].passengertypeId +
        ' .remove-pax a'
    );
    if (adultCount > minCount) {
      this.vaPassenger[index].passengerCount =
        parseInt(this.vaPassenger[index].passengerCount) - 1;
      this.totalCount = this.totalCount - 1;
      this.setPassengerValues();
    }
    if (
      this.vaPassenger[index].passengertypeId === this.paxAdults &&
      this.vaPassenger[index].passengerCount ===
        this.vaPassenger[index].passengerMinCount
    ) {
      this.removeTabFocus(index);
    } else if (
      this.vaPassenger[index].passengertypeId === this.paxYoungAdult &&
      this.vaPassenger[index].passengerCount ===
        this.vaPassenger[index].passengerMinCount
    ) {
      this.removeTabFocus(index);
    } else if (
      this.vaPassenger[index].passengertypeId === this.paxChild &&
      this.vaPassenger[index].passengerCount ===
        this.vaPassenger[index].passengerMinCount
    ) {
      this.removeTabFocus(index);
    } else if (
      this.vaPassenger[index].passengertypeId === this.paxLapInfants &&
      this.vaPassenger[index].passengerCount ===
        this.vaPassenger[index].passengerMinCount
    ) {
      this.removeTabFocus(index);
    }
  }

  removeTabFocus(index) {
    const paxAdultIcon = document.querySelector(
      '.pax-optionUL li.pax-' +
        this.vaPassenger[index].passengertypeId +
        ' .remove-pax a'
    );
    if (paxAdultIcon !== undefined || paxAdultIcon !== null) {
      this.ren.addClass(paxAdultIcon, 'remove-img');
      this.ren.removeClass(paxAdultIcon, 'active-remove-img');
      this.ren.setAttribute(paxAdultIcon, 'tabindex', '-1');
      this.el.nativeElement.querySelector('.active-add-img').focus();
    }
  }

  setPassengerValues() {
    const passengers = [];
    for (let i = 0; i < this.vaPassenger.length; i++) {
      passengers.push(this.vaPassenger[i]);
    }
    this.setTotalPassengerDesc();
    this.setPassenger.emit(passengers);
  }

  setTotalPassengerDesc() {
    this.totalPassengerDescription = '';
    for (let i = 0; i < this.vaPassenger.length; i++) {
      this.totalPassengerDescription =
        this.totalPassengerDescription +
        this.getDesc(
          this.vaPassenger[i].passengerCount,
          this.vaPassenger[i].passengerSingular,
          this.vaPassenger[i].passengerPlural
        );
      if (i < this.vaPassenger.length - 2) {
        this.totalPassengerDescription = this.totalPassengerDescription + ',';
      }
    }
  }

  setRecentSearchPassenger(recentSearchSelected) {
    this.recentSearchSelected = recentSearchSelected;
    this.recentSearchsAvailable = true;
    this.setSelectedRecentSearch(recentSearchSelected);
  }

  getDesc(count, singular, plural) {
    const desc = count === 1 ? singular : count > 1 ? plural : singular;
    return count + ' ' + desc;
  }

  setSelectedRecentSearch(recentSearchSelected) {
    for (let i = 0; i < this.vaPassenger.length; i++) {
      if (this.vaPassenger[i].passengertypeId === 'ADT') {
        this.vaPassenger[i].passengerCount =
          this.recentSearchSelected.adtCount !== undefined
            ? this.getPaxCunt(this.recentSearchSelected.adtCount, i)
            : this.vaPassenger[i].passengerCount;
        this.adultCount = this.vaPassenger[i].passengerCount;
        this.totalCount = parseInt(this.vaPassenger[i].passengerCount);
      } else if (this.vaPassenger[i].passengertypeId === 'GBE') {
        this.vaPassenger[i].passengerCount =
          this.recentSearchSelected.gbeCount !== undefined
            ? this.getPaxCunt(this.recentSearchSelected.gbeCount, i)
            : this.vaPassenger[i].passengerCount;
        this.yngAdultCount = this.vaPassenger[i].passengerCount;
        this.totalCount =
          this.totalCount + parseInt(this.vaPassenger[i].passengerCount);
      } else if (this.vaPassenger[i].passengertypeId === 'CNN') {
        this.vaPassenger[i].passengerCount =
          this.recentSearchSelected.cnnCount !== undefined
            ? this.getPaxCunt(this.recentSearchSelected.cnnCount, i)
            : this.vaPassenger[i].passengerCount;
        this.childCount = this.vaPassenger[i].passengerCount;
        this.totalCount =
          this.totalCount + parseInt(this.vaPassenger[i].passengerCount);
      } else if (this.vaPassenger[i].passengertypeId === 'INF') {
        this.vaPassenger[i].passengerCount =
          this.recentSearchSelected.infantCount !== undefined
            ? this.getPaxCunt(this.recentSearchSelected.infantCount, i)
            : this.vaPassenger[i].passengerCount;
        this.infantCount = this.vaPassenger[i].passengerCount;
        this.totalCount =
          this.totalCount + parseInt(this.vaPassenger[i].passengerCount);
      }
    }
    this.setPassengerValues();
  }

  setSavedSearchPassengers(adultValue) {
    const passengerArray = this.content.passengertype;
    this.vaPassenger = [];
    for (let i = 0; i < passengerArray.length; i++) {
      if (passengerArray[i].passengertypeId === 'ADT') {
        passengerArray[i].passengerCount = this.getPaxCunt(adultValue, i);
        this.adultCount = passengerArray[i].passengerCount;
        this.totalCount = parseInt(passengerArray[i].passengerCount);
      } else {
        passengerArray[i].passengerCount = passengerArray[i].passengerMinCount;
      }
      this.vaPassenger.push(passengerArray[i]);
    }
    this.setPassengerValues();
  }

  getSavedPaxCunt(paxCount, index) {
    let count = paxCount === undefined || paxCount === null ? 0 : paxCount;
    if (count === 0) {
      count = this.content.passengertype[index].passengerMinCount;
    } else {
      count = count;
    }
    return count;
  }

  testEvent(event: any) {
    // console.log(event.keyCode);
  }

  private getRecentSearchCallParams() {
    const tripType = this.cookieHelper.getTripType();
    if (tripType === 'multicity') {
      const mc_cache_key = this.cookieHelper.getMcCacheKey();
      if (mc_cache_key && mc_cache_key.length) {
        console.log(
          '%c getRecentSearchCallParams returned getUncachedMultiCityRecentSearches',
          'color:yellow'
        );
        return {
          serviceCall:
            this.trackerDataService.getUncachedMultiCityRecentSearches(
              mc_cache_key
            ),
          multicity: true
        };
      }
    }
    console.log(
      '%c getRecentSearchCallParams returned getRecentSearches',
      'color:yellow'
    );
    return {
      serviceCall: this.trackerDataService.getRecentSearches(),
      multicity: false
    };
  }
}
